import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedApproaches } from './components/FailedApproaches';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
function initMetaPixel(pixelId: string) {
  if (window.fbq) return;
  const fbq = function (...args: any[]) {
    if ((fbq as any).callMethod) {
      ;
      (fbq as any).callMethod.apply(fbq, args);
    } else {
      ;
      (fbq as any).queue.push(args);
    }
  } as any;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [] as any[];
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    initMetaPixel('1279876863600581');
  }, []);
  return <div className="min-h-screen bg-charcoal font-sans text-cream selection:bg-amber selection:text-charcoal" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <HookSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <FailedApproaches data-id="element-5" />
        <UniqueMechanism data-id="element-6" />
        <WhatYouGet data-id="element-7" />
        <WhoIsFor data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <ProofSection data-id="element-10" />
        <FaqSection data-id="element-11" />
        <FinalCta data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}